module.exports = __webpack_public_path__ + "img/product_icon_bf.d07d10db.png";